import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';
import { helveticaBold } from '../../theme-constants/typograhy-overrides';



export const genericStepperStyles = makeStyles((theme) => ({
    genericStepperContainer: {

        '&.generic-stepper-tabs': {
            borderBottom: `1px solid ${tcsmColors.greyFive}`,
        },
        '& .MuiTabs-scrollButtons': {
            '& svg': {
                fill: tcsmColors.blue,
            },
        },
        '& .MuiTabs-indicator': {
            backgroundColor: 'transparent',
        },
        '& .generic-stepper': {
            '&-tab': {
                '&-desktop': {
                    display: 'flex',
                    justifyContent: 'space-between',
                    paddingRight: theme.spacing(3),
                    paddingLeft: theme.spacing(3),
                    '&-inner': {
                        display: 'flex',
                    },
                },
                '&-item': {
                    border: 'none',
                    paddingRight: theme.spacing(3.5),
                    paddingLeft: theme.spacing(3.5),
                    color: tcsmColors.blue,
                    background: tcsmColors.greySix,
                    borderTop: '2px solid white',
                    paddingBottom: theme.spacing(1.5),
                    paddingTop: theme.spacing(1.5),
                    [theme.breakpoints.down('md')]: {
                        paddingBottom: theme.spacing(1),
                        paddingTop: theme.spacing(1),
                        paddingRight: theme.spacing(3),
                        paddingLeft: theme.spacing(3),

                    },
                    '& + .generic-stepper-tab-item': {
                        borderLeft: `1px solid ${tcsmColors.greyFour}`,
                    },
                    ' &[disabled]': {
                        background: 'white',
                        borderLeftColor: 'transparent',
                        borderTop: `2px solid ${tcsmColors.greyOne}`,
                        position: 'relative',
                        color: tcsmColors.black,
                        '&:after': {
                            content: '""',
                            position: 'absolute',
                            display: 'block',
                            width: '100%',
                            height: '1px',
                            background: 'white',
                            bottom: '-1px',
                            right: '0',
                        },
                        '& + .generic-stepper-tab-item': {
                            borderLeftColor: 'transparent',
                        },
                    },
                    '&-inner': {

                        borderBottom: '4px solid transparent',
                        '&.active': {
                            borderColor: tcsmColors.blue,
                        },
                    },
                },
                '&-infobar': {
                    paddingTop: theme.spacing(.5),
                },
            },
            '&-bar': {
                '& .MuiTabs-scroller': {
                    paddingBottom: theme.spacing(1),
                    paddingTop: theme.spacing(1),
                },
            },
            '&-item': {
                marginRight: theme.spacing(.75),
                display: 'flex',
                flex: '0 0 auto',
                alignItems: 'center',
                '&-status': {
                    margin: '-1px',
                    padding: '0',
                    width: '1px',
                    height: '1px',
                    overflow: 'hidden',
                    clip: 'rect(0, 0, 0, 0)',
                    position: 'absolute',
                },
                '&.pending': {
                    fontFamily: helveticaBold,
                },
                '&.disabled': {
                    color: tcsmColors.greyFour,
                },

                '& + .generic-stepper-item': {

                    '&:before': {
                        borderStyle: 'solid',
                        borderColor: tcsmColors.greyFour,
                        borderWidth: '0.15rem 0.15rem 0 0',
                        content: '""',
                        display: 'block',
                        height: '0.75rem',
                        position: 'relative',
                        transform: 'rotate(45deg)',
                        width: '0.75rem',
                        marginRight: theme.spacing(.75),
                    },
                },
                '&-icon': {

                    '& > svg': {
                        display: 'none',
                        fill: tcsmColors.black,
                        [theme.breakpoints.down('md')]: {
                            width: '1rem',
                            height: '1rem',

                        },
                    },

                    '&.completed': {

                        '& > svg': {
                            display: 'block',
                        },
                    },
                },
            },
            '&-infobar': {
                paddingTop: theme.spacing(.5),
                paddingLeft: theme.spacing(1),
            },
        },

        '& .generic-ministepper': {
            borderBottom: `1px solid ${tcsmColors.greyFive}`,
            [theme.breakpoints.up('md')]: {
                display: 'flex',
                justifyContent: 'space-between',
                paddingRight: theme.spacing(3),
                alignItems: 'center',
            },
            '&-infobar': {
                paddingBottom: theme.spacing(1),
                paddingTop: theme.spacing(1),
            },
        },
    },



}));




